"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Quote } from "lucide-react";
const testimonials = [{
  author: "Azienda Alpha",
  quote: "DCLegal ci ha assistito con competenza e professionalità in tutte le fasi della negoziazione contrattuale.",
  position: "Direttore Commerciale",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/logo_alpha_company.png"
}, {
  author: "Beta S.r.l.",
  quote: "Lo studio ha fornito consulenza strategica che ha fatto la differenza nel nostro processo di espansione.",
  position: "CEO",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/logo_beta_srl.png"
}, {
  author: "Gamma Industries",
  quote: "Un partner legale affidabile e proattivo. La loro attenzione ai dettagli è impareggiabile nel settore.",
  position: "CFO",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/logo_gamma_industries.png"
}, {
  author: "Delta Group",
  quote: "Grazie a DCLegal abbiamo risolto complessi contenziosi con rapidità ed efficacia. Consigliatissimi.",
  position: "General Counsel",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/logo_delta_group.png"
}];
export default function ParolaAiNostriClienti() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}